<script lang="ts">
  import JoinWaitList from "./JoinWaitList.svelte";
  import checkMobileDevice from "../../common/is-mobile";

  const isMobile = checkMobileDevice();
</script>

<footer>
  <div class="waitlist-footer" class:mobile={isMobile}>
    <div class="waitlist-container">
      <JoinWaitList />
    </div>
  </div>
</footer>

<style lang="postcss">
  footer {
    @apply block;
  }

  .waitlist-footer {
    /* height: 264px;
    min-height: 264px; */
    width: 100%;
    padding: 0px 8px 8px 8px;
  }

  /* .waitlist-footer.mobile {
    height: 280px;
    min-height: 280px;
  } */

  .waitlist-container {
    @apply relative flex flex-col items-center justify-center w-full h-full rounded;
    background: linear-gradient(90.95deg, #3bc7ff 0%, #5f89ff 100%);
    box-shadow: 5px 5px 15px rgba(55, 84, 170, 0.16);
    padding-top: 60px;
    padding-bottom: 80px;
  }

  .mobile .waitlist-container {
    padding-top: 52px;
    padding-bottom: 80px;
  }

  .waitlist-container::before {
    @apply absolute left-0 right-0 top-0 bottom-0 pointer-events-none;
    content: "";
    background-image: url(/images/background-logo.svg);
    background-repeat: no-repeat;
    background-position: left calc(60% + 300px) top -120px;
  }

  .waitlist-footer.mobile .waitlist-container::before {
    background-position: left calc(50% + 200px) top -60px;
  }
</style>
